/* global $ */

import { Controller } from 'stimulus';
import serializeFormToObject from '../helpers/serializeFormToObject';
import {
  getLabelTextForInput,
  getInputForKeyAndValue,
  getDefaultForInput,
  renderSelectedFilter,
  deleteFilterForButton,
} from '../helpers/filterHelpers';
import hasHistorySupport from '../helpers/hasHistorySupport';
import createEvent from '../helpers/createEvent';
import debounce from '../helpers/debounce';

const API_URL = '/api/products-html';

class Filter extends Controller {
  connect() {
    this.filterDebounced = debounce(this.filter.bind(this), 10);

    this.onFilterChange();
  }

  onFilterChange() {
    this.filterDebounced();

    const priceField = this.element.querySelector('[name="price[from]"]');

    if (priceField) {
      createEvent(priceField, 'update');
    }
  }

  onConfirmClick() {
    this.closeAllDropdowns();
  }

  onShowResults() {
    this.closeFilter();
  }

  closeFilter() {
    $(this.element.querySelector('#filter')).collapse('hide');
  }

  onWindowClick(event) {
    const { target } = event;
    const sectionElement = target.closest('.filter__section');

    if (!sectionElement) {
      this.closeAllDropdowns();
    }
  }

  closeAllDropdowns() {
    const dropdownNodes = this.element.querySelectorAll('.filter__section-collapse');
    const dropdowns = Array.prototype.slice.call(dropdownNodes);

    dropdowns.forEach((dropdown) => {
      $(dropdown).collapse('hide');
    });
  }

  onDeleteFilter(e) {
    deleteFilterForButton(e.target.closest('button'));
    this.onFilterChange();
  }

  onDeleteFilters() {
    this.selectedDeleteButtonsTargets.forEach(deleteFilterForButton);
    this.onFilterChange();
  }

  getSelectedFilters() {
    const selectedValues = serializeFormToObject(this.formTarget);
    const selectedItems = [];

    selectedValues.forEach((val, key) => {
      if (!val) {
        return;
      }

      if (key === 'sort') {
        return;
      }

      const label = getLabelTextForInput(key, val);
      const input = getInputForKeyAndValue(key, val);
      const defaultValue = getDefaultForInput(input);

      if (input.value === defaultValue || !label) {
        return;
      }

      selectedItems.push({
        key,
        value: val,
        label,
      });
    });

    return selectedItems;
  }

  outputSelectedFilters(filters) {
    this.selectedTarget.innerHTML = filters.map(renderSelectedFilter).join('');

    this.selectedTarget.style.display = filters.length > 0 ? 'block' : 'none';
  }

  filter() {
    this.emptyResults();
    this.toggleSpinner(true);

    this.outputSelectedFilters(this.getSelectedFilters());

    const parameters = $(this.formTarget).serialize();
    const canonical = document.querySelector('link[rel="canonical"]').href;

    if (hasHistorySupport()) {
      const url = `${canonical}${parameters ? '?' : ''}${parameters}`;
      try {
        window.history.replaceState(null, null, url);
      } catch (error) {
        //
      }
    }

    $.get(`${API_URL}?${parameters}`)
      .then((res) => {
        this.toggleSpinner(false);
        this.resultsTarget.innerHTML = res.products;
        this.resultsCountTargets.forEach((target) => {
          target.innerHTML = `${res.count} ${res.count === 1 ? 'resultaat' : 'resultaten'}`;
          target.style.display = 'inline-block';
        });
      });
  }

  emptyResults() {
    this.resultsTarget.innerHTML = '';
  }

  toggleSpinner(state) {
    this.spinnerTarget.style.display = state ? 'block' : 'none';
  }
}

Filter.targets = [
  'form',
  'selected',
  'selectedDeleteButtons',
  'spinner',
  'results',
  'resultsCount',
];

export default Filter;
